import { render, staticRenderFns } from "./address-module.vue?vue&type=template&id=74ecc3f0&scoped=true"
import script from "./address-module.vue?vue&type=script&lang=js"
export * from "./address-module.vue?vue&type=script&lang=js"
import style0 from "./address-module.vue?vue&type=style&index=0&id=74ecc3f0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74ecc3f0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\mrzhj\\Desktop\\ff\\frontent\\takeout\\www\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74ecc3f0')) {
      api.createRecord('74ecc3f0', component.options)
    } else {
      api.reload('74ecc3f0', component.options)
    }
    module.hot.accept("./address-module.vue?vue&type=template&id=74ecc3f0&scoped=true", function () {
      api.rerender('74ecc3f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/address/address-module.vue"
export default component.exports